module.exports = __webpack_public_path__ + "bd60209fcd0d0e0d3b9badb82dfe84d8.pdf";